import React from "react";

import UiDragIcon from "components/icons/DragIcon";

import Box from "@mui/material/Box";

import "./styles.css";

const DragIcon = () => {
  return (
    <Box className="ui-drag-icon" >
      <UiDragIcon />
    </Box>
  );
};

export default DragIcon;
